import React, { useEffect, useState } from 'react'
import {
  loadSofaElement,
  type ModuleExports,
} from '@/configurator/DynamicLoadSofaShape'
import { LazyShapeThumbnail } from '@/components/shared/inputComponents/SofaFormTypeGridSelect'
import type { MappingParams } from '../params'

/** Small Konva drawing of the mapped type with the mapping's params applied. */
export function MappingShapeThumb({
  type,
  params,
  width = 96,
  height = 72,
}: {
  type?: string | null
  params: MappingParams
  width?: number
  height?: number
}) {
  const [shapeModule, setShapeModule] = useState<ModuleExports | null>(null)

  useEffect(() => {
    let cancelled = false
    setShapeModule(null)
    if (!type) return
    loadSofaElement(type).then(mod => {
      if (!cancelled && mod) setShapeModule(mod)
    })
    return () => {
      cancelled = true
    }
  }, [type])

  if (!type) {
    return (
      <div
        className="flex items-center justify-center rounded border border-dashed text-[10px] text-muted-foreground"
        style={{ width, height }}
      >
        Not mapped
      </div>
    )
  }
  if (!shapeModule) {
    return (
      <div
        className="animate-pulse rounded bg-muted/50"
        style={{ width, height }}
      />
    )
  }
  return (
    <div className="rounded bg-muted/20">
      <LazyShapeThumbnail
        shapeModule={shapeModule}
        width={width}
        height={height}
        variant={params as Record<string, number | string | boolean>}
      />
    </div>
  )
}
